import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import Sidebar from 'components/sidebar/Sidebar';
import SidebarLink from 'components/sidebar/SidebarLink';
import joinPath from 'utilities/joinPath';


const CategoriesSidebar = ({ categories }) => {
    const match = useRouteMatch();
    
    return (
        <Sidebar>
            {categories?.map(({ slug, name }) => (
                <SidebarLink
                    key={slug}
                    to={joinPath(match.url, slug)}
                    text={name}
                />
            ))}
        </Sidebar>
    );
};


export default CategoriesSidebar;
